/**
 * @created on 2017/10/27
 * @author laixinyu <laixinyualex@gmail.com>
 **/

import { getRunTime } from '../../../../public-resource/libs/utils/index'

// 判断环境
let M_HOST = getRunTime('//m.xinli001.com')
let STATIC_HOST = getRunTime('//static.xinli001.com')
let KC_HOST = getRunTime('//kc.xinli001.com')

module.exports = {
  mHost: M_HOST,
  staticHost: STATIC_HOST,
  share: ``,
  wxJSSDK: ``,
  like: `${M_HOST}/lesson/comment/zan`,
  login: `${M_HOST}/account/login`,
  getComment: `${M_HOST}/lesson/rate-list`,
  lessonIndex: `${getRunTime(
    window.location.href.indexOf('xinli001.cc') !== -1
      ? '//m.xinli001.cc'
      : '//m.xinli001.com'
  )}/lesson`,
  // lessonpro: `${getRunTime('//static.xinli001.com')}/msite/index.html#/teacher?type=pro`,
  // 新的咨询师课首页
  lessonpro: `${getRunTime('//m.xinli001.com')}/lesson/proIndex?lessonType=pro`,
  getWXShareConfig: `${M_HOST}/wx/get-wx-package.json`,
  updatePlayTime: `${M_HOST}/lesson/markPlayInfo`,
  sendComment: `${M_HOST}/lesson/rate-`,
  getPeriodList: `${M_HOST}/lesson/getPeriodList`, // ?lesson_id=141&flag=1
  // 判断是否打卡，lessonId，keshiId，keshiType
  periodClock: `${KC_HOST}/lingxikc/lesson/periodClock`
}



// WEBPACK FOOTER //
// ./src/pages/lesson/play/module/apis.js